/**
 * 每日账户变动详情
 */
import React, { Component } from 'react';
import { Modal, Button } from 'antd';

import PageTable from '../../ui/PageTable';

class MemberDayStatistics extends Component {

    columns = [{
        title: '日期',
        dataIndex: 'date',
        width: '10%',
    }, {
        title: '交易台数',
        dataIndex: 'tradeNumber',
        width: '10%',
    }, {
        title: '消费金额',
        dataIndex: 'consumeAmount',
        width: '10%',
    }, {
        title: '开票金额',
        dataIndex: 'invoiceAmount',
        width: '10%',
    }, {
        title: '扣款金额',
        dataIndex: 'deductionAmount',
        width: '10%',
    }, {
        title: '实际充值金额',
        dataIndex: 'rechargeActualAmount',
        width: '10%',
    }, {
        title: '赠送金额',
        dataIndex: 'rechargeGiftAmount',
        width: '10%',
    }, {
        title: '剩余金额',
        dataIndex: 'account',
        width: '10%',
    }];

    state ={

    }

    componentWillReceiveProps(that) {
        if (that.visible === true) {
            let queryData = { "memberCode": that.editData.memberCode, "month": that.month };
            if (this.state.loadData) {
                this.state.loadData(queryData);
            }
        }
    }

    render() {
        const { visible, editData, month } = this.props;
        return (
            <Modal
                width={900}
                centered={true}
                visible={visible}
                title= {month+" "+editData.memberName}
                okText="确定"
                cancelText="取消"
                maskClosable={false}
                onCancel={this.props.onCancel}
                footer={[
                    <Button key="take" type="primary" onClick={this.props.onCancel}>确定</Button>,
                ]}
            >
                <PageTable
                    rowKey="id"
                    url="/memberAccountStatistics/findDayStatistics"
                    columns={this.columns}
                    page={false}
                    loadData={(func) => { this.setState({ loadData: func }) }}
                    initParams={{ memberCode: editData.memberCode, month: month }}
                >
                </PageTable>
            </Modal>
        )
    }
}

export default MemberDayStatistics;